import { memo, useState } from "react"
import { Button, Popover, PopoverBody, Nav, NavItem, NavLink, TabContent } from "reactstrap"
import { Funnel as FilterIcon } from 'react-bootstrap-icons'
import { FilterContent } from "./components/FilterContent"
import { find } from 'lodash'

const FILTER_MODAL = {
    isOpen: false,
    query: {},
    activeTab: 1
}

export const Filter = memo(({ filterCriteria }: { filterCriteria: any }) => {
    const [filterPopover, setFilterPopover] = useState(FILTER_MODAL)
    const { isOpen, activeTab } = filterPopover

    const toggleFilterPopover = () => {
        setFilterPopover({ ...filterPopover, isOpen: !isOpen })
    }

    const toggleTabs = (status: number) => {
        setFilterPopover({ ...filterPopover, activeTab: status })
    }
    const handleDiscardAndClose = () => setFilterPopover(FILTER_MODAL)

    const activeCriteria = find(filterCriteria, (o) => { return o.id === activeTab; });


    console.log("filter", filterPopover)
    console.log("filterCriteria", filterCriteria)
    return (
        <>
            <Button
                id="filter-button"
                type="button"
                onClick={toggleFilterPopover}
                className="filter-button-body"
            >
                <FilterIcon  />
                Filter
            </Button>
            {isOpen && (<Popover
               
                target="filter-button"
                isOpen={isOpen}
                placement="bottom"
                popperClassName="filter-popover"
            >
                <PopoverBody>
                    <div className="filter-box d-flex">

                        <Nav tabs vertical>
                            {filterCriteria.map((row: { id: any; tabHeading: any }, index: number) => {
                                const { id, tabHeading } = row
                                return (
                                    <NavItem key={`tab-${tabHeading}-${id}-${index + 1}`}>
                                        <NavLink
                                            className={id === activeTab ? "active" : ''}
                                            onClick={() => toggleTabs(id)}
                                        >
                                            {tabHeading}
                                        </NavLink>
                                    </NavItem>
                                )
                            })}


                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <FilterContent activeCriteria={activeCriteria}/>
                            <div className="popover-footer">
                            <Button outline className="outline">Apply</Button>
                            <Button outline className="mx-2">Clear</Button>
                            <Button outline className="mx-2 close-button" onClick={handleDiscardAndClose}>Discard & Close</Button>
                        </div>
                        </TabContent>
                    </div>


                </PopoverBody>
            </Popover>)}
        </>
    )
});
